module.exports = __webpack_public_path__ + "static/media/3DPPA33.f53ab18b.jpg";